import { injectable } from 'inversify'
import { consts } from './consts'
import { GeoLocationModel } from './GeoLocationModel'

function createGeolocationModel(headerDictionary: Record<string, string>): GeoLocationModel {
  return {
    areaCode: headerDictionary['areacode'] ?? '',
    city: headerDictionary['city'] ?? '',
    continent: headerDictionary['continent'] ?? '',
    countryCode: headerDictionary['country_code'] ?? '',
    county: headerDictionary['county'] ?? '',
    geoRegion: headerDictionary['georegion'] ?? '',
    regionCode: headerDictionary['region_code'] ?? '',
    timezone: headerDictionary['timezone'] ?? '',
    zip: headerDictionary['zip'] ?? '',
    lat: parseFloat(headerDictionary['lat']) || 0,
    long: parseFloat(headerDictionary['long']) || 0,
  }
}

@injectable()
export class GeoLocationService {
  getGeoLocation(headers: Record<string, string>): GeoLocationModel | null {
    try {
      const headerValue = headers[consts.AkamaiEdgescape]
      if (!headerValue) {
        return null
      }
      return this.getGeoLocationFromValue(headerValue)
    } catch (error) {
      console.error(error)
      return null
    }
  }

  getGeoLocationFromValue(headerValue: string): GeoLocationModel {
    if (headerValue) {
      const headerItems = headerValue.split(',').map((headerItem) => headerItem.trim())

      const headerDictionaryList = headerItems
        .map((headerItem) => headerItem.split('='))
        .filter((headerItem) => headerItem?.length == 2)
        .map((headerItem) => [headerItem[0].trim().toLocaleLowerCase(), headerItem[1].trim()])

      const headerDictionary = Object.fromEntries(headerDictionaryList) as Record<string, string>
      return createGeolocationModel(headerDictionary)
    } else {
      return createGeolocationModel({})
    }
  }
}

//  DON'T DELETE - used by DW
